import { generatePlantProfile } from '@/lib/generatedProfiles';
import {
  type CanonicalPlant,
  normalizeGeneratedPlantToPlant,
} from '@/lib/normalizePlant';

export async function createMissingPlantProfile(query: string): Promise<CanonicalPlant | null> {
  const plantName = query.trim();
  if (!plantName) return null;

  const profile = await generatePlantProfile(plantName);
  return profile ? normalizeGeneratedPlantToPlant(profile) : null;
}
